package com.example.hukakmp.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.example.hukakmp.data.AiQuotaRepository
import com.example.hukakmp.reportchat.ConversationalReportDraft
import com.example.hukakmp.reportchat.ConversationalReportResult
import com.example.hukakmp.reportchat.extractConversationalReport
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class ConversationalReportViewModel(
    private val quotaRepository: AiQuotaRepository,
) : ViewModel() {

    data class UiState(
        val isAnalyzing: Boolean = false,
        val draft: ConversationalReportDraft? = null,
        val error: String? = null,
        val chatsRemaining: Int = 5,
        val chatsTotal: Int = 5,
    )

    private val _uiState = MutableStateFlow(UiState())
    val uiState: StateFlow<UiState> = _uiState.asStateFlow()

    init {
        refreshQuota()
    }

    fun refreshQuota() {
        viewModelScope.launch {
            val quota = quotaRepository.getState()
            _uiState.value = _uiState.value.copy(
                chatsRemaining = quota.chatsRemaining,
                chatsTotal = quota.chatsTotal,
            )
        }
    }

    fun analyze(text: String) {
        val clean = text.trim()
        if (clean.isBlank() || _uiState.value.isAnalyzing) return

        viewModelScope.launch {
            val quota = quotaRepository.getState()
            if (quota.chatsRemaining <= 0) {
                _uiState.value = _uiState.value.copy(
                    error = "Alcanzaste el límite diario de consultas de Huka. Se renueva al comenzar un nuevo día.",
                    chatsRemaining = 0,
                    chatsTotal = quota.chatsTotal,
                )
                return@launch
            }

            _uiState.value = _uiState.value.copy(
                isAnalyzing = true,
                draft = null,
                error = null,
                chatsRemaining = quota.chatsRemaining,
                chatsTotal = quota.chatsTotal,
            )

            when (val result = extractConversationalReport(clean)) {
                is ConversationalReportResult.Success -> {
                    val consumed = quotaRepository.consumeChat()
                    _uiState.value = _uiState.value.copy(
                        isAnalyzing = false,
                        draft = result.draft,
                        error = null,
                        chatsRemaining = consumed?.chatsRemaining ?: quota.chatsRemaining,
                        chatsTotal = consumed?.chatsTotal ?: quota.chatsTotal,
                    )
                }

                is ConversationalReportResult.Error -> {
                    _uiState.value = _uiState.value.copy(
                        isAnalyzing = false,
                        error = result.message,
                    )
                }
            }
        }
    }

    fun clearDraft() {
        _uiState.value = _uiState.value.copy(draft = null, error = null)
    }

    fun clearError() {
        _uiState.value = _uiState.value.copy(error = null)
    }
}
